import React from 'react';
export function Process() {
  const steps = [{
    num: '01',
    title: 'BOOK IT',
    desc: 'Pick your package and lock in a date online. Takes 2 minutes.'
  }, {
    num: '02',
    title: 'WE ROLL UP',
    desc: 'We arrive with the gear, the steam, and the elbow grease.'
  }, {
    num: '03',
    title: 'THE MAGIC',
    desc: 'Deep clean, degrease, sanitize, and polish every inch.'
  }, {
    num: '04',
    title: 'GRILL OUT',
    desc: 'Your grill looks brand new. Time to buy some steaks.'
  }];
  return <section className="bg-otter-bone py-24" data-id="element-258">
      <div className="container mx-auto px-4" data-id="element-259">
        <div className="mb-16 text-center" data-id="element-260">
          <h2 className="font-display text-6xl tracking-tighter text-otter-black sm:text-7xl" data-id="element-261">
            HOW IT{' '}
            <span className="text-otter-cyan text-stroke-black" data-id="element-262">WORKS</span>
          </h2>
        </div>

        <div className="relative mx-auto max-w-6xl" data-id="element-263">
          {/* Connecting Line (Desktop) */}
          <div className="absolute left-0 top-16 hidden w-full border-t-4 border-dashed border-otter-cyan lg:block" data-id="element-264" />

          <div className="grid gap-12 lg:grid-cols-4 lg:gap-8" data-id="element-265">
            {steps.map((step, idx) => <div key={idx} className="relative flex flex-col items-center text-center" data-id="element-266">
                <div className="relative z-10 flex h-32 w-32 items-center justify-center rounded-full border-4 border-otter-black bg-otter-cyan shadow-brutal" data-id="element-267">
                  <span className="font-display text-6xl text-otter-black" data-id="element-268">
                    {step.num}
                  </span>
                </div>
                <h3 className="mt-8 font-display text-3xl tracking-wider text-otter-black" data-id="element-269">
                  {step.title}
                </h3>
                <p className="mt-4 font-body text-lg font-medium text-otter-black/70" data-id="element-270">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}